// Create simple default data for each widget type
export const createDefaultWidgetData = (widgetType: string) => {
  const baseData = {
    title: `New ${widgetType}`,
    backgroundColor: "#ffffff",
    textColor: "#1f2937",
  };

  // Add specific defaults based on widget type
  switch (widgetType) {
    case 'BasicBanner':
      return {
        slides: [
          {
            id: 'banner-basic-1',
            title: '<h2><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Lorem Ipsum Dolor Sit Amet</span></h2>',
            subtitle: '<h4><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Consectetur Adipiscing Elit</span></h4>',
            description: '<p><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></p>',
            backgroundImage: 'https://t4.ftcdn.net/jpg/07/34/49/51/360_F_734495125_nbu79okmH77f6XpIiQqBOmE67U0YzZen.jpg',
            backgroundVideo: '',
            backgroundColor: '#000000',
            textAlignment: 'center',
            textColor: '#ffffff',
            overlayOpacity: 0.5,
            overlayColor: 'rgba(0,0,0,0.5)',
            autoplayDelay: 5000,
            ctaButtons: [
              {
                id: 'cta-1',
                text: '<span style="color:#ffffff;">Lorem Ipsum</span>',
                url: '#order',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'primary',
                backgroundColor: '#EF4444',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              },
              {
                id: 'cta-2',
                text: '<span style="color:#ffffff;">Lorem Ipsum</span>',
                url: '#menu',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'outline',
                backgroundColor: '#EF4444',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              }
            ]
          },
          {
            id: 'banner-basic-2',
            title: '<h2><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Sed Ut Perspiciatis Unde</span></h2>',
            subtitle: '<h4><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Omnis Iste Natus Error</span></h4>',
            description: '<p><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.</span></p>',
            backgroundImage: 'https://www.huongnghiepaau.com/wp-content/uploads/2019/01/lam-banh-pizza-banh-chao-600x401.jpg',
            backgroundVideo: '',
            backgroundColor: '#1a1a1a',
            textAlignment: 'center',
            textColor: '#ffffff',
            overlayOpacity: 0.6,
            overlayColor: 'rgba(0,0,0,0.6)',
            autoplayDelay: 5000,
            ctaButtons: [
              {
                id: 'cta-1',
                text: '<span style="color:#ffffff;">Dolor Sit</span>',
                url: '#explore',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'primary',
                backgroundColor: '#3B82F6',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              },
              {
                id: 'cta-2',
                text: '<span style="color:#ffffff;">Amet Lorem</span>',
                url: '#discover',
                navItemUrl: '/story',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'outline',
                backgroundColor: '#3B82F6',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              }
            ]
          }
        ]
      };

    case 'ClassicBanner':
      return {
        slides: [
          {
            id: 'banner-classic-1',
            title: '<h2><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Lorem Ipsum Dolor Sit Amet</span></h2>',
            subtitle: '<h4><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Consectetur Adipiscing Elit</span></h4>',
            description: '<p><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></p>',
            backgroundImage: 'https://t4.ftcdn.net/jpg/07/34/49/51/360_F_734495125_nbu79okmH77f6XpIiQqBOmE67U0YzZen.jpg',
            backgroundVideo: '',
            backgroundColor: '#000000',
           textAlignment: 'center',
            textColor: '#ffffff',
            overlayOpacity: 0.5,
            overlayColor: 'rgba(0,0,0,0.5)',
            sectionBackgroundColor: '#000000',
            autoplayDelay: 5000,
            ctaButtons: [
              {
                id: 'cta-1',
                text: '<span style="color:#ffffff;">Lorem Ipsum</span>',
                url: '#order',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'primary',
                backgroundColor: '#EF4444',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              },
              {
                id: 'cta-2',
                text: '<span style="color:#ffffff;">Lorem Ipsum</span>',
                url: '#menu',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'outline',
                backgroundColor: '#EF4444',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              }
            ]
          },
          {
            id: 'banner-classic-2',
            title: '<h2><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Nemo Enim Ipsam Voluptatem</span></h2>',
            subtitle: '<h4><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Quia Voluptas Sit Aspernatur</span></h4>',
            description: '<p><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.</span></p>',
            backgroundImage: 'https://www.huongnghiepaau.com/wp-content/uploads/2019/01/lam-banh-pizza-banh-chao-600x401.jpg',
            backgroundVideo: '',
            backgroundColor: '#2d2d2d',
           textAlignment: 'center',
            textColor: '#ffffff',
            overlayOpacity: 0.4,
            overlayColor: 'rgba(0,0,0,0.4)',
            sectionBackgroundColor: '#1a1a1a',
            autoplayDelay: 5000,
            ctaButtons: [
              {
                id: 'cta-1',
                text: '<span style="color:#ffffff;">Tempor Incididunt</span>',
                url: '#reserve',
                navItemUrl: '/reservations',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'primary',
                backgroundColor: '#10B981',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              },
              {
                id: 'cta-2',
                text: '<span style="color:#ffffff;">Ut Labore</span>',
                url: '#contact',
                navItemUrl: '/contact',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'outline',
                backgroundColor: '#10B981',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              }
            ]
          }
        ]
      };

    case 'EssentialBanner':
      return {
        slides: [
          {
            id: 'banner-essential-1',
            title: '<h2><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Lorem Ipsum Dolor Sit Amet</span></h2>',
            subtitle: '<h4><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Consectetur Adipiscing Elit</span></h4>',
            description: '<p><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></p>',
            backgroundImage: 'https://t4.ftcdn.net/jpg/07/34/49/51/360_F_734495125_nbu79okmH77f6XpIiQqBOmE67U0YzZen.jpg',
            backgroundVideo: '',
            backgroundColor: '#000000',
           textAlignment: 'center',
            textColor: '#ffffff',
            overlayOpacity: 0.5,
            overlayColor: 'rgba(0,0,0,0.5)',
            sectionBackgroundColor: '#000000',
            autoplayDelay: 5000,
            ctaButtons: [
              {
                id: 'cta-1',
                text: '<span style="color:#ffffff;">Lorem Ipsum</span>',
                url: '#order',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'primary',
                backgroundColor: '#EF4444',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              },
              {
                id: 'cta-2',
                text: '<span style="color:#ffffff;">Lorem Ipsum</span>',
                url: '#menu',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'outline',
                backgroundColor: '#EF4444',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              }
            ]
          },
          {
            id: 'banner-essential-2',
            title: '<h2><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Quis Autem Vel Eum Iure</span></h2>',
            subtitle: '<h4><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Reprehenderit Qui In Ea</span></h4>',
            description: '<p><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur.</span></p>',
            backgroundImage: 'https://www.huongnghiepaau.com/wp-content/uploads/2019/01/lam-banh-pizza-banh-chao-600x401.jpg',
            backgroundVideo: '',
            backgroundColor: '#3d3d3d',
            textAlignment: 'center',
            textColor: '#ffffff',
            overlayOpacity: 0.55,
            overlayColor: 'rgba(0,0,0,0.55)',
            sectionBackgroundColor: '#2d2d2d',
            autoplayDelay: 5000,
            ctaButtons: [
              {
                id: 'cta-1',
                text: '<span style="color:#ffffff;">Et Dolore</span>',
                url: '#menu',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'primary',
                backgroundColor: '#F59E0B',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              },
              {
                id: 'cta-2',
                text: '<span style="color:#ffffff;">Magnam Aliquam</span>',
                url: '#about',
                navItemUrl: '/story',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'outline',
                backgroundColor: '#F59E0B',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              }
            ]
          }
        ]
      };

    case 'PrimeBanner':
      return {
        slides: [
          {
            id: 'banner-prime-1',
            title: '<h2><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Lorem Ipsum Dolor Sit Amet</span></h2>',
            subtitle: '<h4><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Consectetur Adipiscing Elit</span></h4>',
            description: '<p><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></p>',
            backgroundImage: 'https://t4.ftcdn.net/jpg/07/34/49/51/360_F_734495125_nbu79okmH77f6XpIiQqBOmE67U0YzZen.jpg',
            backgroundVideo: '',
            backgroundColor: '#000000',
            textAlignment: 'center',
            textColor: '#ffffff',
            overlayOpacity: 0.5,
            overlayColor: 'rgba(0,0,0,0.5)',
            autoplayDelay: 5000,
            ctaButtons: [
              {
                id: 'cta-1',
                text: '<span style="color:#ffffff;">Lorem Ipsum</span>',
                url: '#order',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'primary',
                backgroundColor: '#EF4444',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              },
              {
                id: 'cta-2',
                text: '<span style="color:#ffffff;">Lorem Ipsum</span>',
                url: '#menu',
                navItemUrl: '/menu',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'outline',
                backgroundColor: '#EF4444',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              }
            ]
          },
          {
            id: 'banner-prime-2',
            title: '<h2><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">At Vero Eos Et Accusamus</span></h2>',
            subtitle: '<h4><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">Et Iusto Odio Dignissimos</span></h4>',
            description: '<p><span style="color: rgb(255, 255, 255);" class="force-visible-white-text">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti.</span></p>',
            backgroundImage: 'https://www.huongnghiepaau.com/wp-content/uploads/2019/01/lam-banh-pizza-banh-chao-600x401.jpg',
            backgroundVideo: '',
            backgroundColor: '#2a2a2a',
            textAlignment: 'center',
            textColor: '#ffffff',
            overlayOpacity: 0.45,
            overlayColor: 'rgba(0,0,0,0.45)',
            autoplayDelay: 5000,
            ctaButtons: [
              {
                id: 'cta-1',
                text: '<span style="color:#ffffff;">Qui Blanditiis</span>',
                url: '#gallery',
                navItemUrl: '/gallery',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'primary',
                backgroundColor: '#8B5CF6',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              },
              {
                id: 'cta-2',
                text: '<span style="color:#ffffff;">Praesentium</span>',
                url: '#events',
                navItemUrl: '/events',
                linkType: 'nav-item',
                openInNewTab: false,
                variant: 'outline',
                backgroundColor: '#8B5CF6',
                color: '#ffffff',
                outlineColor: '#ffffff',
                visible: true
              }
            ]
          }
        ]
      };

    case 'ClassicNav':
      return {
        ...baseData,
        logoText: "Restaurant",
        logoUrl: "",
        items: [
          { id: "1", label: "Menu", url: "/menu" },
          { id: "2", label: "Our Story", url: "/story" },
          { id: "3", label: "Blog", url: "/blog" },
          { id: "4", label: "Contact", url: "/contact" },
        ],
      };

    case 'BasicExperienceCard':
    case 'ClassicExperienceCard':
    case 'EssentialExperience':
      return {
        ...baseData,
        title: "Why Choose Paradise Biryani Pointe",
        subtitle: "What makes us special",
        backgroundColor: "#f9fafb",
        items: [
          {
            id: "1",
            title: "Fresh Ingredients",
            description: "We source the finest ingredients daily to ensure every dish is fresh and flavorful",
            icon: "🥬",
            image: "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=400&h=300&fit=crop"
          },
          {
            id: "2",
            title: "Authentic Recipes",
            description: "Traditional recipes passed down through generations, prepared with love and care",
            icon: "👨‍🍳",
            image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=300&fit=crop"
          },
          {
            id: "3",
            title: "Fast Delivery",
            description: "Hot, fresh food delivered to your door in 30 minutes or less",
            icon: "🚚",
            image: "https://images.unsplash.com/photo-1526367790999-0150786686a2?w=400&h=300&fit=crop"
          }
        ]
      };

    case 'BasicPopularItems':
    case 'ClassicPopularItems':
    case 'PrimePopularItems':
      return {
        content: '<h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our <span class="text-red-600">Popular</span> Items</h2><p class="text-gray-600 text-lg max-w-2xl mx-auto">Discover our most loved dishes, crafted with passion and served with pride</p>',
        backgroundColor: "#ffffff",
        selectedItemIds: [],
        emptyStateContent: '<h3 class="text-lg sm:text-xl font-semibold mb-2">No Popular Items Available</h3><p class="text-sm sm:text-base max-w-md">Our popular items will be displayed here soon.</p>',
        menuData: [],
        showRating: false
      };

    case 'BasicCombo':
    case 'ClassicCombo':
    case 'PrimeCombo':
      return {
        content: '<h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our <span class="text-red-600">Special</span> Combos</h2><p class="text-gray-600 text-lg max-w-2xl mx-auto">Discover our amazing combo deals, perfect for sharing</p>',
        backgroundColor: "#ffffff",
        combos: [],
        emptyStateContent: '<h3 class="text-lg sm:text-xl font-semibold mb-2">No Combos Available</h3><p class="text-sm sm:text-base max-w-md">Our combo deals will be displayed here soon.</p>'
      };

    case 'EssentialFooter':
      return {
        ...baseData,
        restaurantName: "Restaurant Name",
        phone: "Call & Order: (555) 123-4567",
        email: "info@restaurant.com",
        address: "123 Main Street, City, State 12345",
        hours: "Mon-Thu: 11am-10pm | Fri-Sat: 11am-11pm | Sun: 12pm-9pm",
        quickLinks: [
          { id: "1", label: "Menu", url: "/menu" },
          { id: "2", label: "Order Online", url: "/order" },
        ],
        socialLinks: [
          { id: "1", platform: "facebook", url: "#" }
        ],
        copyright: "© 2024 Restaurant Name. All rights reserved.",
        backgroundColor: "#1f2937",
        textColor: "#f9fafb",
      };

    case 'BasicContactForm':
      return {
        ...baseData,
        title: '<h1 class="text-4xl md:text-5xl font-bold mb-4">Get In <span class="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">Touch</span></h1>',
        subtitle: '<p class="text-gray-600 text-lg leading-relaxed max-w-2xl mx-auto">Ready to build something amazing together? Drop us a line and let\'s start creating.</p>',
        form: {
          name: {
            enabled: true,
            required: true,
            placeholder: "Name",
            label: "Name"
          },
          email: {
            enabled: true,
            required: true,
            placeholder: "Email",
            label: "Email"
          },
          phone: {
            enabled: true,
            required: false,
            placeholder: "Phone",
            label: "Phone"
          },
          message: {
            enabled: true,
            required: true,
            placeholder: "Message",
            label: "Message"
          }
        },
        contactInfo: {
          email: {
            address: "hello@buildabyte.com",
            description: "We'll respond within 24 hours"
          },
          phone: {
            number: "+1 (123) 456-7890",
            description: "Mon-Fri from 9am to 6pm"
          },
          address: {
            full: "123 Creative Ave, Tech City, CA 94107",
            description: "Come say hello at our office"
          }
        },
        backgroundColor: "#ffffff",
        textColor: "#1f2937",
        formBackgroundColor: "#ffffff",
        cardBackgroundColor: "#ffffff",
        primaryColor: "#dc2626",
        successMessage: "Thank you for your message! We'll get back to you soon.",
        errorMessage: "Something went wrong. Please try again."
      };

    case 'BasicStory':
      return {
        ...baseData,
        hero: {
          image: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=1200&h=600&fit=crop',
          title: 'Our Story'
        },
        storyContent: `<p><strong>The Story of Pizza House: A Slice of Happiness</strong></p>
<p>Once upon a time in a small bustling town, there was a cozy little restaurant called Pizza House. It all began with a passionate chef, Marco, who dreamed of sharing his love for authentic Italian pizza with the community.</p>
<p>Marco had grown up in Naples, where the aroma of freshly baked bread and bubbling tomato sauce was a daily delight. With a small oven and a big heart, Marco opened Pizza House in a humble storefront.</p>
<p>His secret was simple: use the freshest ingredients, craft each pizza with care, and serve it with a smile. Word quickly spread about his delicious, handcrafted pies topped with ripe tomatoes, fragrant basil, and gooey mozzarella.</p>`
      };

    case 'BasicBlog':
    case 'ClassicBlog':
    case 'ModernBlog':
    case 'PrimeBlog':
      return {
        ...baseData,
        title: '<h1 class="text-4xl md:text-5xl font-bold mb-4">Latest <span class="bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">Stories</span></h1>',
        subtitle: '<p class="text-gray-600 text-lg leading-relaxed">Discover the stories behind our dishes, ingredients, and culinary traditions.</p>',
        posts: [
          {
            id: "1",
            title: "The Art of Perfect Pizza Dough",
            content: "Learn the secrets behind creating the perfect pizza dough that forms the foundation of every great pizza. From selecting the right flour to mastering fermentation techniques.",
            excerpt: "Discover the time-honored techniques and secret ingredients that make our pizza dough exceptional.",
            image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=800&h=600&fit=crop",
            date: new Date().toISOString(),
            readTime: 5,
            category: "Techniques",
            chef: "Marco Rossi",
            isEnabled: true
          },
          {
            id: "2",
            title: "Farm to Table: Our Ingredient Journey",
            content: "Follow the journey of our fresh ingredients from local farms to your plate. We partner with sustainable farms to bring you the freshest seasonal produce.",
            excerpt: "Explore our commitment to fresh, locally-sourced ingredients and sustainable farming practices.",
            image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=800&h=600&fit=crop",
            date: new Date().toISOString(),
            readTime: 7,
            category: "Ingredients",
            chef: "Sarah Johnson",
            isEnabled: true
          },
          {
            id: "3",
            title: "The History of Italian Cuisine",
            content: "Take a culinary journey through Italy's rich gastronomic history. From ancient Roman feasts to modern Italian innovations, discover how tradition shapes our menu.",
            excerpt: "A fascinating exploration of Italian culinary traditions that inspire our authentic recipes.",
            image: "https://images.unsplash.com/photo-1498579397066-22750a3cb424?w=800&h=600&fit=crop",
            date: new Date().toISOString(),
            readTime: 8,
            category: "Culture",
            chef: "Giuseppe Bianchi",
            isEnabled: true
          }
        ],
        postsPerPage: 6,
        showCategory: true,
        showReadTime: true,
        showAuthor: true,
        showDate: true,
        backgroundColor: "#ffffff",
        textColor: "#1f2937",
        cardBackgroundColor: "#ffffff",
        primaryColor: "#dc2626"
      };

    case 'BasicEvents':
      return {
        ...baseData,
        section: {
          title: "The place to celebrate",
          subtitle: "Join us for special occasions and memorable moments"
        },
        items: [
          {
            id: "1",
            image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=600&fit=crop",
            title: "Wine Tasting Evening",
            description: "Join us for an exclusive wine tasting featuring premium selections from renowned vineyards. Experience the perfect pairing of fine wines with our signature appetizers.",
            date: "2024-04-15",
            time: "19:00",
            location: "Main Dining Room",
            isPublished: true
          },
          {
            id: "2",
            image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop",
            title: "Chef's Table Experience",
            description: "An intimate dining experience where our head chef prepares a multi-course meal right before your eyes. Limited seating for an unforgettable culinary journey.",
            date: "2024-04-22",
            time: "18:30",
            location: "Chef's Kitchen",
            isPublished: true
          },
          {
            id: "3",
            image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&h=600&fit=crop",
            title: "Live Jazz & Dinner",
            description: "Enjoy smooth jazz melodies while savoring our finest dishes. A perfect evening combining great music, exceptional food, and elegant ambiance.",
            date: "2024-04-29",
            time: "20:00",
            location: "Lounge Area",
            isPublished: true
          }
        ],
        isEnabled: true
      };

    case 'BasicGallery':
      return {
        ...baseData,
        section: {
          title: "Pizza Moments",
          subtitle: "Capturing the magic behind every bite"
        },
        images: [
          {
            image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=500&h=500&fit=crop",
            title: "Delicious Pizza",
            description: "Fresh ingredients and authentic flavors",
            isPublished: true
          },
          {
            image: "https://images.unsplash.com/photo-1571997478779-2adcbbe9ab2f?w=500&h=500&fit=crop",
            title: "Cozy Atmosphere",
            description: "Perfect dining experience",
            isPublished: true
          },
          {
            image: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=500&h=500&fit=crop",
            title: "Fresh Ingredients",
            description: "Quality you can taste",
            isPublished: true
          },
          {
            image: "https://images.unsplash.com/photo-1590947132387-155cc02f3212?w=500&h=500&fit=crop",
            title: "Artisan Crafted",
            description: "Made with passion",
            isPublished: true
          },
          {
            image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=500&h=500&fit=crop",
            title: "Wood Fired",
            description: "Traditional cooking methods",
            isPublished: true
          },
          {
            image: "https://images.unsplash.com/photo-1571407970349-bc81e7e96d47?w=500&h=500&fit=crop",
            title: "Happy Customers",
            description: "Creating memorable moments",
            isPublished: true
          }
        ],
        isEnabled: true
      };

    case 'LeftContentRightMediaLayout':
      return {
  title: '<h1>Lorem Ipsum</h1>',
  description: `<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium. Proin egestas, velit in convallis tempus, justo arcu egestas urna, ut fermentum velit urna in nisl. Nulla facilisi. Integer et diam at nunc elementum volutpat a in lorem. Suspendisse potenti. Donec sodales, nisl in convallis viverra, turpis nulla tempus nisi, vel tincidunt velit magna a est.</p>`,
  ctaText: '<span>Lorem Ipsum</span>',
  ctaLink: '#',
  ctaColor: '#C83E4D',
  backgroundColor: '#FFF8E7',
  images: [
    {
      src: 'https://picsum.photos/seed/left1/600/400',
      alt: 'Placeholder image 1'
    },
    {
      src: 'https://picsum.photos/seed/left2/600/400',
      alt: 'Placeholder image 2'
    },
    {
      src: 'https://picsum.photos/seed/left3/600/400',
      alt: 'Placeholder image 3'
    }
  ]
};


    case 'RightContentLeftMediaLayout':
      return {
  title: '<h1>Lorem Ipsum</h1>',
  description: `<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium. Proin egestas, velit in convallis tempus, justo arcu egestas urna, ut fermentum velit urna in nisl. Nulla facilisi. Integer et diam at nunc elementum volutpat a in lorem. Suspendisse potenti. Donec sodales, nisl in convallis viverra, turpis nulla tempus nisi, vel tincidunt velit magna a est.</p>`,
  ctaText: '<span>Lorem Ipsum</span>',
  ctaLink: '#',
  ctaColor: '#C83E4D',
  backgroundColor: '#FFF8E7',
  images: [
    {
      src: 'https://picsum.photos/seed/right1/600/400',
      alt: 'Placeholder image 1'
    },
    {
      src: 'https://picsum.photos/seed/right2/600/400',
      alt: 'Placeholder image 2'
    },
    {
      src: 'https://picsum.photos/seed/right3/600/400',
      alt: 'Placeholder image 3'
    }
  ]
};


    case 'SplitPromoCard':
      return {
  title: '<h1>Lorem Ipsum</h1>',
  description: `<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium. Proin egestas, velit in convallis tempus, justo arcu egestas urna, ut fermentum velit urna in nisl. Nulla facilisi. Integer et diam at nunc elementum volutpat a in lorem. Suspendisse potenti. Donec sodales, nisl in convallis viverra, turpis nulla tempus nisi, vel tincidunt velit magna a est.</p>`,
  ctaText: '<span>Lorem Ipsum</span>',
  ctaLink: '#',
  ctaColor: '#C83E4D',
  backgroundColor: '#FFF8E7',
  images: [
    {
      src: 'https://picsum.photos/seed/split1/600/400',
      alt: 'Placeholder image 1'
    },
    {
      src: 'https://picsum.photos/seed/split2/600/400',
      alt: 'Placeholder image 2'
    },
    {
      src: 'https://picsum.photos/seed/split3/600/400',
      alt: 'Placeholder image 3'
    }
  ]
};


    case 'BasicSocialFollow':
      return {
        title: '<h3>Lorem ipsum dolor sit amet</h3>',
        backgroundColor: '#FFFFFF',
        images: [
          {
            src: 'https://as1.ftcdn.net/v2/jpg/10/22/24/80/1000_F_1022248039_7LDxHRi3Mlt9BK3wzLBUGZp9XAO1gt2s.jpg',
            alt: 'Placeholder image 1',
            size: 'M'
          },
          {
            src: 'https://as1.ftcdn.net/v2/jpg/10/22/24/80/1000_F_1022248039_7LDxHRi3Mlt9BK3wzLBUGZp9XAO1gt2s.jpg',
            alt: 'Placeholder image 2',
            size: 'L'
          },
          {
            src: 'https://as1.ftcdn.net/v2/jpg/10/22/24/80/1000_F_1022248039_7LDxHRi3Mlt9BK3wzLBUGZp9XAO1gt2s.jpg',
            alt: 'Placeholder image 3',
            size: 'S'
          },
          {
            src: 'https://as1.ftcdn.net/v2/jpg/10/22/24/80/1000_F_1022248039_7LDxHRi3Mlt9BK3wzLBUGZp9XAO1gt2s.jpg',
            alt: 'Placeholder image 4',
            size: 'XL'
          }
        ],
        videos: [
          {
            src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
            alt: 'Placeholder video 1',
            size: 'L'
          }
        ]
      };

    case 'FullWidthHero':
      return {
        slides: [
          {
            id: 'hero-1',
            backgroundImage: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1920&h=800&fit=crop',
            content: '<h1 style="font-size: 3rem; font-weight: bold; margin-bottom: 1rem;">Welcome to Our Restaurant</h1><p style="font-size: 1.5rem;">Experience culinary excellence</p>',
            ctaText: 'Book Now',
            ctaLink: '#',
            ctaLinkType: 'custom',
            ctaColor: '#EF4444',
            overlayOpacity: 0.5,
            overlayColor: '#000000',
            duration: 4000
          }
        ]
      };

    case 'CustomizableForm':
      return {
        headerContent: '<h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Private Event Inquiry</h2><p class="text-lg text-gray-600">Fill out the form below and we will contact you soon</p>',
        backgroundColor: '#F9FAFB',
        fields: {
          fullName: {
            id: 'fullName',
            label: 'Full Name',
            type: 'text',
            placeholder: 'e.g. Nina Simone',
            required: true,
            enabled: true,
            order: 1
          },
          phone: {
            id: 'phone',
            label: 'Phone',
            type: 'tel',
            placeholder: 'e.g. (123) 456-7890',
            required: true,
            enabled: true,
            order: 2
          },
          email: {
            id: 'email',
            label: 'Email',
            type: 'email',
            placeholder: 'e.g. cris@example.com',
            required: true,
            enabled: true,
            order: 3
          },
          company: {
            id: 'company',
            label: 'Company',
            type: 'text',
            placeholder: 'Name of your business...',
            required: false,
            enabled: true,
            order: 4
          },
          numberOfPeople: {
            id: 'numberOfPeople',
            label: 'Number of People',
            type: 'select',
            required: true,
            enabled: true,
            order: 5,
            options: ['6 People', '7 People', '8 People', '9 People', '10 People', '11 People', '12 People', '13 People', '14 People', '15 People', '16 People', '17 People', '18 People', '19 People', '20 People']
          },
          date: {
            id: 'date',
            label: 'Select Date',
            type: 'date',
            required: true,
            enabled: true,
            order: 6
          },
          time: {
            id: 'time',
            label: 'Select Time',
            type: 'time',
            required: true,
            enabled: true,
            order: 7
          },
          duration: {
            id: 'duration',
            label: 'Duration',
            type: 'text',
            placeholder: 'Enter estimated duration (e.g. 2 hours)...',
            required: false,
            enabled: true,
            order: 8
          },
          occasion: {
            id: 'occasion',
            label: 'Select Occasion',
            type: 'select',
            required: true,
            enabled: true,
            order: 9,
            options: ['Anniversary', 'Baby Shower', 'Bachelor Party', 'Bachelorette Party', 'Bar Mitzvah', 'Bat Mitzvah', 'Birthday', 'Bridal Shower', 'Business/Office/Corporate Function', 'Family Reunion', 'Graduation', 'Holiday Party', 'Quinceañera', 'Rehearsal Dinner', 'Repast/Memorial Service Reception', 'Retirement', 'Wedding', 'Other']
          },
          budget: {
            id: 'budget',
            label: 'Budget per Person',
            type: 'number',
            placeholder: '$30',
            required: false,
            enabled: true,
            order: 10
          },
          description: {
            id: 'description',
            label: 'Description / Requests',
            type: 'textarea',
            placeholder: 'Any Special Requests?...',
            required: false,
            enabled: true,
            order: 11
          },
          howDidYouHear: {
            id: 'howDidYouHear',
            label: 'How did you hear about us?',
            type: 'select',
            required: false,
            enabled: true,
            order: 12,
            options: ['Search engine', 'Social media', 'Email Newsletter', 'Word of Mouth', 'I\'m an existing customer', 'Other']
          },
          marketingConsent: {
            id: 'marketingConsent',
            label: 'I agree to receive marketing text messages about specials, events, and other exclusive offers. My consent is not required to make a reservation.',
            type: 'checkbox',
            required: false,
            enabled: true,
            order: 13
          }
        },
        cta: {
          text: 'Submit Request',
          backgroundColor: '#EF4444',
          textColor: '#FFFFFF',
          enabled: true
        },
        successMessage: 'Thank you for your inquiry! We will contact you soon to discuss your private event.',
        errorMessage: 'Something went wrong. Please try again or call us directly.'
      };

    default:
      return baseData;
  }
};

/**
 * Ensures navigation widget data has all required default values for missing keys.
 * Uses nullish coalescing (??) to only set defaults for undefined/null keys.
 * Preserves existing values (including false).
 * 
 * @param data - The navigation widget data to process
 * @returns Navigation data with defaults applied for missing keys
 */
export const defaultNavData = (data: any) => {
  if (!data) return data;

  return {
    ...data,
    
    // Basic branding properties
    logoText: data.logoText ?? "",
    logoUrl: data.logoUrl ?? "",
    contactInfo: data.contactInfo ?? "",
    fontFamily: data.fontFamily ?? "",
    
    // Color properties
    backgroundColor: data.backgroundColor ?? "#000000",
    textColor: data.textColor ?? "#f1f5f9",
    
    // Cart & Order Button properties
    showCartIcon: data.showCartIcon ?? true,
    showOrderButton: data.showOrderButton ?? false,
    orderButtonText: data.orderButtonText ?? "Order Online",
    orderButtonUrl: data.orderButtonUrl ?? "",
    
    // Action button properties
    showTakeout: data.showTakeout ?? true,
    takeoutText: data.takeoutText ?? "Takeout",
    showDelivery: data.showDelivery ?? true,
    deliveryText: data.deliveryText ?? "Delivery",
    deliveryUrl: data.deliveryUrl ?? "",
    showCallToOrder: data.showCallToOrder ?? true,
    callToOrderText: data.callToOrderText ?? "Call to Order",
    callToOrderNumber: data.callToOrderNumber ?? "",
    
    // Announcement bar properties
    showAnnouncementBar: data.showAnnouncementBar ?? false,
    announcementContent: data.announcementContent ?? "",
    
    // Hero Bar properties
    showHeroBar: data.showHeroBar ?? false,
    showHeroBarLabel: data.showHeroBarLabel ?? false,
    showSocialIcons: data.showSocialIcons ?? false,
    heroBarLabel: data.heroBarLabel ?? "",
    heroBarBackgroundColor: data.heroBarBackgroundColor ?? "#2d5a4a",
    heroBarTextColor: data.heroBarTextColor ?? "#ffffff",
    
    // Social Media properties
    enableFacebook: data.enableFacebook ?? false,
    enableInstagram: data.enableInstagram ?? false,
    enableFoursquare: data.enableFoursquare ?? false,
    enableYelp: data.enableYelp ?? false,
    enableTripadvisor: data.enableTripadvisor ?? false,
    enableEmail: data.enableEmail ?? false,
    enableTiktok: data.enableTiktok ?? false,
    socialMedia: data.socialMedia ?? {},
    
    // Transparency properties
    isTransparent: data.isTransparent ?? false,
    enableScrollTransparency: data.enableScrollTransparency ?? false,
    
    // Nav items - ensure each has submenu defaults
    items: (data.items || []).map((item: any) => ({
      ...item,
      hasSubMenu: item.hasSubMenu ?? false,
      subMenuItemIds: item.subMenuItemIds ?? [],
      isEnabled: item.isEnabled ?? true,
      dropdownLabel: item.dropdownLabel ?? ""
    }))
  };
};
